import {IServiceFactory} from "../../../../service-factory.interface";
import {SpecialAssistanceSsrBase} from "../special-assistance-ssr-base";

//Wheelchair required for transfer to/from AC - can walk, no steps
export default class WchsSsrType extends SpecialAssistanceSsrBase {
    constructor(services: IServiceFactory) {
        super('WCHS', services);
    }

}
